import { BiCategoryAlt, BiFootball } from "react-icons/bi";
import { GiPokerHand } from "react-icons/gi";
import { FaDharmachakra } from "react-icons/fa";
import { FiTarget, FiStar, FiGift } from "react-icons/fi";
import { MdOutlineAttachMoney } from "react-icons/md";
import { RiCoinLine } from "react-icons/ri";

// Kategori adını normalize et (Türkçe karakter sadeleştirme)
export const normalizeCat = (s) => (s || "").toLowerCase()
  .replace(/ü/g, "u").replace(/ı/g, "i").replace(/ö/g, "o")
  .replace(/ğ/g, "g").replace(/ş/g, "s").replace(/ç/g, "c")
  .replace(/\s+/g, "");

// Kategori → SVG ikon (rozet, filtre ve onay modalı aynı eşlemeyi kullanır)
export const getCategoryIcon = (cat) => {
  switch (normalizeCat(cat)) {
    case "spor": return <BiFootball />;
    case "casino": return <GiPokerHand />;
    case "cark": return <FaDharmachakra />;
    case "kayip": return <FiTarget />;
    case "hosgeldin": return <FiStar />;
    case "yatirim": return <MdOutlineAttachMoney />;
    case "deneme": return <FiGift />;
    case "haftalik": return <RiCoinLine />;
    default: return <BiCategoryAlt />; // tümü, genel vs.
  }
};
